module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-1-4.89a8f517.png";